if (!customElements.get('nutrition-facts')) {
  class NutritionFacts extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-nf-open]');
      if (!this.dialog || !this.trigger) return;

      this.trigger.addEventListener('click', this.open.bind(this));
      this.querySelector('[data-nf-close]')?.addEventListener('click', this.close.bind(this));

      // Clicking the backdrop reports the dialog itself as the target, since the
      // backdrop is painted by the dialog rather than by a child element.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      // Fires for both close() and the browser's own Escape handling.
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('overflow-hidden');
      });
    }

    open() {
      this.dialog.showModal();
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.dialog.close();
    }
  }

  customElements.define('nutrition-facts', NutritionFacts);
}
